import { useContext, useEffect, useState } from 'react';
import Flatpickr from 'react-flatpickr';
import { TimeAttendanceEventsAPI } from '../../../../../services/external/APIs/timeAttendanceEvents/TimeAttendanceEventsAPI';
import { AppContext } from '../../../../context';
import { Modal } from '../../BaseModal';
import { TimeAttendanceEvents } from '../TimeAttendanceEvent';
import { UpdateTimeAttendanceEventsModalProps } from '../TimeAttendanceEventsModalProps';
import UbicationSelector from '../components/UbicationSelector';
import { LoadingTable } from '../../../../../pages/request-management/components/table';
import { toast } from 'react-toastify';

const ModifyMarkingModal = ({
    setModalOpen,
    saveTimeAttendanceEvents,
    isOpen,
    employee,
    startDate,
    endDate,
    workshifts,
}: UpdateTimeAttendanceEventsModalProps) => {
    const { langResources } = useContext(AppContext);

    const [eventTypeValue, setEventTypeValue] = useState('');
    const [marking, setMarking] = useState<TimeAttendanceEvents>({
        eventDate: '',
        eventId: 0,
        eventType: 0,
        ubicationDescription: '',
        ubicationId: 0,
        observations: '',
    } as TimeAttendanceEvents);
    const [allMarkings, setAllMarkings] = useState<TimeAttendanceEvents[]>([]);
    const [selectedMarkingsIds, setSelectedMarkingsIds] = useState<number[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState('Completa todos los campos');

    const handleCloseModal = () => {
        setMarking({} as TimeAttendanceEvents);
        setEventTypeValue('');
        setModalOpen(false);
    };

    const handleInputChange = (
        name: string,
        value: string | number | number[] | boolean
    ) => {
        let newValue = value;

        if (name === 'eventDate') {
            newValue = marking.eventDate.split('T')[0] + 'T' + value;
        }

        let newMarking = { ...marking, [name]: newValue };

        let newList = [...allMarkings];

        newList = newList.map((x) => {
            if (x.eventId == newMarking.eventId) {
                return newMarking;
            }

            return x;
        });

        setAllMarkings(newList);
        setMarking(newMarking);
    };

    const handlerSubmit = () => {
        saveTimeAttendanceEvents(
            allMarkings.map((marking) => ({
                date: marking.eventDate,
                eventId: marking.eventId,
                eventTypeId: marking.eventType,
                ubicationId: marking.ubicationId,
                observation: marking.observations,
            }))
        );
        setModalOpen(false);
    };

    const handlerChangeEventype = (e: string) => {
        setEventTypeValue(e);

        setMarking({ ...marking, eventType: Number(e) });
    };

    useEffect(() => {
        setIsLoading(true);

        TimeAttendanceEventsAPI.getAllTimeAttendanceEventsByEmployee({
            date: startDate,
            employeeId: Number(employee?.at(0)?.id),
        })
            .then((res) => {
                setAllMarkings(res);
            })
            .finally(() => setIsLoading(false));
    }, [employee]);

    const handlerChangeMarking = (id: number) => {
        const existMarking = selectedMarkingsIds.includes(id);
        if (existMarking) {
            setSelectedMarkingsIds((prev) => [...prev].filter((m) => m !== id));
        } else {
            setSelectedMarkingsIds((prev) => [...prev, id]);
        }
    };

    const handlerDeleteMarkings = () => {
        setIsLoading(true);
        const id = toast.loading('Eliminando marcaciones manuales...');

        TimeAttendanceEventsAPI.deleteTimeAttendances(selectedMarkingsIds)
            .then((res) => {
                setModalOpen(false);
                toast.update(id, {
                    render: 'Se eliminarón marcaciones manuales exitosamente',
                    type: 'success',
                    isLoading: false,
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: true,
                });
            })
            .catch((error) =>
                toast.update(id, {
                    render: 'Ocurrió un error al eliminar marcaciones manuales',
                    type: 'error',
                    isLoading: false,
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: true,
                })
            )
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Modal
            isOpen={isOpen}
            modalTitle={langResources['marking.modal']['modify.marking.title']}
            onClose={handleCloseModal}
            onSubmit={handlerSubmit}
            disableSubmit={allMarkings.length == 0}
        >
            <div className='modal-body text-black border rounded justify-content-center rounded row mb-0 pb-0'>
                {isLoading ? (
                    <LoadingTable />
                ) : allMarkings.length > 0 ? (
                    <div className='row'>
                        <div className='col-8'>
                            <h5>
                                {langResources['marking.modal']['select.marking']}:
                            </h5>
                            <div className='table-responsive w-100'>
                                <table className='align-middle table-nowrap mb-0 w-100'>
                                    <thead>
                                        <tr>
                                            <th scope='col'></th>
                                            <th scope='col'>
                                                {
                                                    langResources['marking.modal'][
                                                        'ubication'
                                                    ]
                                                }
                                            </th>
                                            <th scope='col'>
                                                {
                                                    langResources['marking.modal'][
                                                        'date'
                                                    ]
                                                }
                                            </th>
                                            <th scope='col'>
                                                {
                                                    langResources['marking.modal'][
                                                        'dateHour'
                                                    ]
                                                }
                                            </th>
                                            <th scope='col'>
                                                {
                                                    langResources['marking.modal'][
                                                        'type'
                                                    ]
                                                }
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allMarkings.map((m) => (
                                            <tr
                                                className={`${
                                                    m.eventId == marking.eventId
                                                        ? 'text-primary2'
                                                        : ''
                                                }`}
                                                key={m.eventId}
                                                onClick={() => setMarking(m)}
                                            >
                                                <td>
                                                    <div className='form-check checked-custom text-center'>
                                                        <input
                                                            className='form-check-input'
                                                            type='checkbox'
                                                            id='inlineCheckbox2'
                                                            value='option1'
                                                            checked={selectedMarkingsIds.includes(
                                                                m.eventId
                                                            )}
                                                            onChange={() =>
                                                                handlerChangeMarking(
                                                                    m.eventId
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </td>
                                                <td>{m.ubicationDescription}</td>
                                                <td>{m.eventDate.split('T')[0]}</td>
                                                <td>{m.eventDate.split('T')[1]}</td>
                                                <td>
                                                    {m.eventType == 1
                                                        ? langResources[
                                                              'marking.modal'
                                                          ]['entry']
                                                        : langResources[
                                                              'marking.modal'
                                                          ]['exit']}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className='col-4 card pb-3'>
                            <h5>
                                {langResources['marking.modal']['details.marking']}:
                            </h5>

                            <div>
                                <div>
                                    <label htmlFor=''>
                                        {langResources['marking.modal']['date']}
                                    </label>
                                    <p>{marking.eventDate.split('T')[0]}</p>
                                </div>

                                <div>
                                    <label htmlFor=''>
                                        {langResources['marking.modal']['type']}
                                    </label>
                                    <div className='d-flex gap-4 p-0'>
                                        <div className='checked-custom'>
                                            <input
                                                className='form-check-input me-1'
                                                type='radio'
                                                name='marking-event-type'
                                                id='flexRadioDefault1'
                                                checked={marking.eventType === 1}
                                                onChange={(e) =>
                                                    handlerChangeEventype(
                                                        e.target.value
                                                    )
                                                }
                                                value={1}
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexRadioDefault1'
                                            >
                                                {
                                                    langResources['marking.modal'][
                                                        'entry'
                                                    ]
                                                }
                                            </label>
                                        </div>

                                        <div className=' checked-custom'>
                                            <input
                                                className='form-check-input me-1'
                                                type='radio'
                                                name='marking-event-type'
                                                id='flexRadioDefault2'
                                                checked={marking.eventType === 2}
                                                onChange={(e) =>
                                                    handlerChangeEventype(
                                                        e.target.value
                                                    )
                                                }
                                                value={2}
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexRadioDefault2'
                                            >
                                                {
                                                    langResources['marking.modal'][
                                                        'exit'
                                                    ]
                                                }
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className='row mt-3'>
                                    <div className='col-6'>
                                        <label
                                            htmlFor='startDate'
                                            className='form-label d-block'
                                        >
                                            {
                                                langResources['marking.modal'][
                                                    'dateHour'
                                                ]
                                            }
                                        </label>
                                        <Flatpickr
                                            className='form-control text-black'
                                            value={marking.eventDate.split('T')[1]}
                                            onChange={(e) =>
                                                handleInputChange(
                                                    'eventDate',
                                                    e[0].toString().split(' ')[4]
                                                )
                                            }
                                            options={{
                                                enableTime: true,
                                                noCalendar: true,
                                                dateFormat: 'H:i',
                                            }}
                                        />
                                    </div>

                                    <div className='col-6 '>
                                        <UbicationSelector
                                            label={
                                                langResources['marking.modal'][
                                                    'ubication'
                                                ]
                                            }
                                            name='ubicationId'
                                            onChange={handleInputChange}
                                            value={marking.ubicationId}
                                            required={true}
                                        />
                                    </div>
                                </div>

                                <div className='mt-3'>
                                    <label
                                        htmlFor='observation'
                                        className='form-label d-block'
                                    >
                                        {
                                            langResources['marking.modal'][
                                                'observation'
                                            ]
                                        }
                                    </label>
                                    <textarea
                                        value={marking.observations}
                                        onChange={(e) =>
                                            handleInputChange(
                                                'observations',
                                                e.target.value
                                            )
                                        }
                                        name='observation'
                                        placeholder={
                                            langResources['marking.modal'][
                                                'observation.placeholder'
                                            ]
                                        }
                                        style={{
                                            width: '100%',
                                            height: '78%',
                                            resize: 'none',
                                        }}
                                        className='form-control text-black'
                                        id='observation'
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <p>no hay marcaciones manuales</p>
                )}

                <div>
                    <button
                        className='btn btn-danger'
                        disabled={selectedMarkingsIds.length == 0 || isLoading}
                        onClick={handlerDeleteMarkings}
                    >
                        Eliminar ({selectedMarkingsIds.length}) marcaciones
                    </button>
                </div>
            </div>
        </Modal>
    );
};
export default ModifyMarkingModal;
